module.exports = __webpack_public_path__ + "static/media/study220602.3bfaeeeb.png";